// extracted by mini-css-extract-plugin
export var altSecondary = "button-module--altSecondary--30ee5";
export var body = "button-module--body--f6dd3";
export var bodyLarge = "button-module--bodyLarge--f8d26";
export var bodyLargeLight = "button-module--bodyLargeLight--157c8";
export var bodySmall = "button-module--bodySmall--2780b";
export var bold = "button-module--bold--29ae8";
export var btn = "button-module--btn--8592b";
export var btnAltSecondary = "button-module--btnAltSecondary--856e8";
export var btnModal = "button-module--btnModal--79033";
export var btnPrimary = "button-module--btnPrimary--05576";
export var btnSecondary = "button-module--btnSecondary--04e78";
export var btnTertiary = "button-module--btnTertiary--3500e";
export var btnTertiarySolid = "button-module--btnTertiarySolid--657fe";
export var compact = "button-module--compact--5c790";
export var eyebrow = "button-module--eyebrow--c177b";
export var filter = "button-module--filter--d06b0";
export var homepageHeadline = "button-module--homepageHeadline--8c44b";
export var internalHeadline = "button-module--internalHeadline--f1dda";
export var italic = "button-module--italic--76f03";
export var link = "button-module--link--988d8";
export var linkSmall = "button-module--linkSmall--5cfc8";
export var modal = "button-module--modal--28410";
export var primary = "button-module--primary--21c9c";
export var quote = "button-module--quote--d56cc";
export var secondary = "button-module--secondary--7b921";
export var tertiary = "button-module--tertiary--1cb72";
export var tertiaryHover = "button-module--tertiaryHover--542cc";
export var tertiarySolid = "button-module--tertiarySolid--5d7c8";